/**
 * The Brew wordmark's box.
 *
 * On a motion-enabled load `BrewAnimatedLogo` paints three different elements
 * in sequence — the static `<Image>`, `next/dynamic`'s loading fallback, then
 * the Rive canvas — inside the hero heading row, where anything that changes
 * size moves the composer and the whole page below it. One wrapper owns the
 * box and every variant fills it, so that sequence is a repaint and never a
 * reflow. Before this, the `loading` fallback hardcoded its own `h-10 w-28`
 * and dropped the caller's `md:` override, so the row went 64 → 40 → 64px.
 *
 * The caller's className merges onto the WRAPPER. That is what lets
 * `md:h-16 md:w-36` (hero) and `h-10 w-28` (onboarding) both work through
 * tailwind-merge while no variant can override or discard either.
 */
export const BREW_LOGO_BOX_CLASSNAME =
  'relative -mb-[2px] block h-12 w-30 shrink-0'

/** The Rive canvas: it fills the box and draws the mark inside its artboard. */
export const BREW_LOGO_FILL_CLASSNAME = 'block h-full w-full dark:invert'

/**
 * Where the Rive artboard draws the mark inside the box, measured from the
 * rendered canvas: the mark spans 13.6%–80% of the width and 16.7%–85.4% of
 * the height, the rest is the artboard's own margin. The still image is
 * drawn in that same rectangle, so a still-to-canvas swap (or a canvas
 * that never arrives) changes nothing the eye can see.
 */
export const BREW_LOGO_MARK_CLASSNAME =
  'absolute top-[16.7%] left-[13.6%] block h-[68.75%] w-[66.4%] object-contain object-left dark:invert'
